// import toast from 'react-hot-toast';
// import { ApiEndpoints } from '../../services/endpoints';
// import { BASE_URL, apiService } from '../../services/service';
// import {
//     LOGIN,
//     LOGIN_FAIL,
//     LOGIN_SUCCESS,
//     LOGOUT,
//     REGISTER,
//     REGISTER_FAIL,
//     REGISTER_SUCCESS,
//     VERIFY,
//     VERIFY_FAIL,
//     VERIFY_SUCCESS,
//     FORGOTPASSWORD,
//     FORGOTPASSWORD_SUCCESS,
//     FORGOTPASSWORD_FAIL,
//     RESET,
//     RESET_SUCCESS,
//     RESET_FAIL,
//     CLEAR_REQUEST,
//     REFRESH_TOKEN,
//     REFRESH_TOKEN_FAIL,
//     REFRESH_TOKEN_SUCCESS,
//     CREATE_CART_SUCCESS,
// } from '../actionTypes';
// import { setCurrenciesRates } from './currencyActions';

// // Google Login Action
// export const googleLogin = () => async (dispatch) => {
//     try {
//         const backendUrl = process.env.REACT_APP_API_BASE_URL;
//         const redirectUri = window.location.origin; // success redirect
//         const failUri = `${window.location.origin}/register`; // failure redirect
//         // Optionally, you can dispatch a loading action here if you want to show a loader
//         window.location.href = `${backendUrl}/auth/google?redirect_uri=${encodeURIComponent(
//             redirectUri,
//         )}&fail_uri=${encodeURIComponent(failUri)}`;
//     } catch (error) {
//         // Optionally, dispatch an error action or show a toast
//         toast.error('Failed to initiate Google login', { position: 'top-right' });
//     }
// };

// export const userLogin = (data) => async (dispatch) => {
//     try {
//         dispatch({ type: LOGIN });
//         const response = await apiService.post({
//             url: `${BASE_URL}${ApiEndpoints.LOGIN}`,
//             payload: data,
//         });

//         if (response.data && response.data.access_token) {
//             if (response.data.refresh_token) {
//                 localStorage.setItem('refresh_token', JSON.stringify(response.data.refresh_token));
//             }
//             localStorage.setItem('access_token', JSON.stringify(response.data.access_token));
//             localStorage.setItem('token', JSON.stringify(response.data.access_token));

//             dispatch({ type: VERIFY_SUCCESS, payload: response });
//             dispatch({ type: LOGIN_SUCCESS, payload: response.data, userData: data });

//             if (response.data.active_quote_id) {
//                 dispatch({
//                     type: CREATE_CART_SUCCESS,
//                     payload: JSON.parse(response.data.active_quote_id),
//                 });
//             }

//             toast.success('Logged in successfully!', { position: 'top-right' });

//             setTimeout(() => window.location.replace('/dashboard'), 300);
//         } else {
//             const message = response?.message || 'Login failed: missing access token';
//             dispatch({ type: LOGIN_FAIL, error: message });
//             toast.error(message, { position: 'top-right' });
//         }
//     } catch (error) {
//         const message = error?.response?.data?.message ?? error?.message ?? 'Network Error';
//         dispatch({ type: LOGIN_FAIL, error: message });
//         toast.error(message, { position: 'top-right' });
//     }
// };

// export const userReg = (data) => async (dispatch) => {
//     try {
//         dispatch({ type: REGISTER });
//         const response = await apiService.post({
//             url: `${BASE_URL}${ApiEndpoints.REGISTER}`,
//             payload: data,
//         });
//         dispatch({ type: REGISTER_SUCCESS, payload: response, userData: data });
//         toast.success('Registration successful! Please check your email for verification code', {
//             position: 'top-right',
//             duration: 5000, // Show for 5 seconds since it's an important message
//         });
//     } catch (error) {
//         const message = error.message ? error.message : 'Network Error';
//         dispatch({ type: REGISTER_FAIL, error: message });

//         toast.error(message, {
//             position: 'top-right',
//         });
//     }
// };

// export const forgotPassword = (data) => async (dispatch) => {
//     const body = { ...data, platform: data.platform ?? 'agent' };
//     try {
//         dispatch({ type: FORGOTPASSWORD });
//         const response = await apiService.post({
//             url: `${BASE_URL}${ApiEndpoints.FORGOTPASSWORD}`,
//             payload: body,
//         });
//         dispatch({ type: FORGOTPASSWORD_SUCCESS, payload: response, userData: data });
//         toast.success(
//             'Password reset link sent! Please check your email for the verification code',
//             {
//                 position: 'top-right',
//                 duration: 5000,
//             },
//         );
//     } catch (error) {
//         const message = error.message ? error.message : 'Network Error';
//         dispatch({ type: FORGOTPASSWORD_FAIL, error: message });
//         toast.error(message, { position: 'top-right' });
//     }
// };

// export const verifyUser = (data) => async (dispatch) => {
//     const body = { ...data, platform: data.platform ?? 'agent' };
//     try {
//         dispatch({ type: VERIFY });
//         const response = await apiService.post({
//             url: `${BASE_URL}${ApiEndpoints.VERIFY}`,
//             payload: body,
//         });
//         console.log('RESPONSE', response);
//         if (response.data) {
//             console.log('RESPONSE', response);
//             if (response.data.refresh_token) {
//                 localStorage.setItem('refresh_token', JSON.stringify(response.data.refresh_token));
//             }
//             if (response.data.access_token) {
//                 localStorage.setItem('access_token', JSON.stringify(response.data.access_token));
//                 localStorage.setItem('token', JSON.stringify(response.data.access_token));
//             }
//             dispatch({
//                 type: VERIFY_SUCCESS,
//                 payload: response,
//             });

//             if (response.data.active_quote_id) {
//                 dispatch({
//                     type: CREATE_CART_SUCCESS,
//                     payload: JSON.parse(response.data.active_quote_id),
//                 });
//             }

//             toast.success('logged in successfully!', { position: 'top-right' });

//             setTimeout(() => {
//                 window.location.reload();
//             }, 1000);
//         } else {
//             const message = response.message;
//             dispatch({ type: VERIFY_FAIL, error: message });
//         }
//     } catch (error) {
//         const message = error.message ? error.message : 'Network Error';
//         dispatch({ type: VERIFY_FAIL, error: message });

//         toast.error(message, {
//             position: 'top-right',
//         });
//     }
// };

// export const resetPassword = (data) => async (dispatch) => {
//     const body = data;
//     try {
//         dispatch({ type: RESET });
//         const response = await apiService.post({
//             url: `${BASE_URL}${ApiEndpoints.VERIFY}`,
//             payload: body,
//         });

//         dispatch({ type: RESET_SUCCESS, payload: response });
//         dispatch({
//             type: VERIFY_SUCCESS,
//             payload: response,
//         });
//         localStorage.setItem('token', JSON.stringify(response.data.access_token));
//         localStorage.setItem('access_token', JSON.stringify(response.data.access_token));
//         localStorage.setItem('refresh_token', JSON.stringify(response.data.refresh_token));

//         toast.success(
//             'Password reset successful! You are now being logged in with your new password',
//             {
//                 position: 'top-right',
//                 duration: 5000, // Show for 5 seconds since it's an important message
//             },
//         );
//     } catch (error) {
//         const message = error.message ? error.message : 'Network Error';
//         dispatch({ type: RESET_FAIL, error: message });
//         dispatch({ type: CLEAR_REQUEST });
//         toast.error(message, {
//             position: 'top-right',
//         });
//     }
// };

// export const refreshToken = () => async (dispatch) => {
//     let refresh_token = JSON.parse(localStorage.getItem('refresh_token'));
//     let body = { refresh_token };

//     try {
//         dispatch({ type: REFRESH_TOKEN });
//         const response = await apiService.post({
//             url: `${BASE_URL}${ApiEndpoints.REFRESHTOKEN}`,
//             payload: body,
//         });
//         localStorage.setItem('token', JSON.stringify(response.data.access_token));
//         localStorage.setItem('access_token', JSON.stringify(response.data.access_token));
//         dispatch({ type: REFRESH_TOKEN_SUCCESS, payload: response });
//     } catch (error) {
//         const message = error.message ? error.message : 'Network Error';
//         dispatch({ type: REFRESH_TOKEN_FAIL, error: message });
//         dispatch({ type: CLEAR_REQUEST });
//         dispatch({ type: LOGOUT });
//         logoutUser(dispatch);
//         toast.error(message, {
//             position: 'top-right',
//         });
//         localStorage.removeItem('token');
//         localStorage.removeItem('refresh_token');
//         localStorage.removeItem('access_token');
//         window.location.reload();
//     }
// };
// export const clearReq = () => async (dispatch) => {
//     dispatch({ type: CLEAR_REQUEST });
// };

// export const logoutUser = async (dispatch) => {
//     let refresh_token = JSON.parse(localStorage.getItem('refresh_token'));
//     let body = { refresh_token: refresh_token };
//     if (refresh_token) {
//         try {
//             dispatch({ type: LOGOUT });
//             localStorage.removeItem('token');
//             localStorage.removeItem('access_token');
//             localStorage.removeItem('refresh_token');
//             localStorage.removeItem('welcome_popup_seen');
//             dispatch(setCurrenciesRates(null));
//             await apiService.delete({
//                 url: `${BASE_URL}${ApiEndpoints.LOGOUT}`,
//                 payload: { data: body },
//             });
//         } catch (error) {
//             const message = error.message ? error.message : 'Network Error';
//             toast.error(message, {
//                 position: 'top-right',
//             });
//         }
//     } else {
//         dispatch({ type: LOGOUT });
//         dispatch(setCurrenciesRates(null));
//         localStorage.removeItem('token');
//         localStorage.removeItem('refresh_token');
//         localStorage.removeItem('access_token');
//     }
// };

import toast from 'react-hot-toast';
import { ApiEndpoints } from '../../services/endpoints';
import { BASE_URL, apiService } from '../../services/service';
import {
    LOGIN,
    LOGIN_FAIL,
    LOGIN_SUCCESS,
    LOGOUT,
    REGISTER,
    REGISTER_FAIL,
    REGISTER_SUCCESS,
    VERIFY,
    VERIFY_FAIL,
    VERIFY_SUCCESS,
    FORGOTPASSWORD,
    FORGOTPASSWORD_SUCCESS,
    FORGOTPASSWORD_FAIL,
    RESET,
    RESET_SUCCESS,
    RESET_FAIL,
    CLEAR_REQUEST,
    REFRESH_TOKEN,
    REFRESH_TOKEN_FAIL,
    REFRESH_TOKEN_SUCCESS,
    CREATE_CART_SUCCESS,
} from '../actionTypes';
import { setCurrenciesRates } from './currencyActions';

// Google Login Action
export const googleLogin = () => async (dispatch) => {
    try {
        const backendUrl = process.env.REACT_APP_API_BASE_URL;
        const redirectUri = window.location.origin; // success redirect
        const failUri = `${window.location.origin}/register`; // failure redirect
        // Optionally, you can dispatch a loading action here if you want to show a loader
        window.location.href = `${backendUrl}/auth/google?redirect_uri=${encodeURIComponent(
            redirectUri,
        )}&fail_uri=${encodeURIComponent(failUri)}`;
    } catch (error) {
        // Optionally, dispatch an error action or show a toast
        toast.error('Failed to initiate Google login', { position: 'top-right' });
    }
};

export const userLogin = (data) => async (dispatch) => {
    try {
        dispatch({ type: LOGIN });
        const response = await apiService.post({
            url: `${BASE_URL}${ApiEndpoints.LOGIN}`,
            payload: data,
        });

        if (response.data && response.data.access_token) {
            if (response.data.refresh_token) {
                localStorage.setItem('refresh_token', JSON.stringify(response.data.refresh_token));
            }
            localStorage.setItem('access_token', JSON.stringify(response.data.access_token));
            localStorage.setItem('token', JSON.stringify(response.data.access_token));

            dispatch({ type: VERIFY_SUCCESS, payload: response });
            dispatch({ type: LOGIN_SUCCESS, payload: response.data, userData: data });

            if (response.data.active_quote_id) {
                dispatch({
                    type: CREATE_CART_SUCCESS,
                    payload: JSON.parse(response.data.active_quote_id),
                });
            }

            toast.success('Logged in successfully!', { position: 'top-right' });

            // setTimeout(() => window.location.replace('/dashboard'), 300);
        } else {
            /* Error path — DO NOT toast.
               The LoginForm reads authReducer.error and renders the
               message inline under the relevant input. Toasting here
               would create a duplicate notification top-right. */
            const message = response?.message || 'Login failed: missing access token';
            dispatch({ type: LOGIN_FAIL, error: message });
        }
    } catch (error) {
        /* Error path — DO NOT toast (see above).
           Inline error message in LoginForm handles UX. */
        const message = error?.response?.data?.message ?? error?.message ?? 'Network Error';
        dispatch({ type: LOGIN_FAIL, error: message });
    }
};

export const userReg = (data) => async (dispatch) => {
    try {
        dispatch({ type: REGISTER });
        const response = await apiService.post({
            url: `${BASE_URL}${ApiEndpoints.REGISTER}`,
            payload: data,
        });
        dispatch({ type: REGISTER_SUCCESS, payload: response, userData: data });
        toast.success('Registration successful! Please check your email for verification code', {
            position: 'top-right',
            duration: 5000, // Show for 5 seconds since it's an important message
        });
    } catch (error) {
        const message = error.message ? error.message : 'Network Error';
        dispatch({ type: REGISTER_FAIL, error: message });

        toast.error(message, {
            position: 'top-right',
        });
    }
};

export const forgotPassword = (data) => async (dispatch) => {
    const body = { ...data, platform: data.platform ?? 'agent' };
    try {
        dispatch({ type: FORGOTPASSWORD });
        const response = await apiService.post({
            url: `${BASE_URL}${ApiEndpoints.FORGOTPASSWORD}`,
            payload: body,
        });
        dispatch({ type: FORGOTPASSWORD_SUCCESS, payload: response, userData: data });
        toast.success(
            'Password reset link sent! Please check your email for the verification code',
            {
                position: 'top-right',
                duration: 5000,
            },
        );
    } catch (error) {
        const message = error.message ? error.message : 'Network Error';
        dispatch({ type: FORGOTPASSWORD_FAIL, error: message });
        toast.error(message, { position: 'top-right' });
    }
};

export const verifyUser = (data) => async (dispatch) => {
    const body = { ...data, platform: data.platform ?? 'agent' };
    try {
        dispatch({ type: VERIFY });
        const response = await apiService.post({
            url: `${BASE_URL}${ApiEndpoints.VERIFY}`,
            payload: body,
        });
        console.log('RESPONSE', response);
        if (response.data) {
            console.log('RESPONSE', response);
            if (response.data.refresh_token) {
                localStorage.setItem('refresh_token', JSON.stringify(response.data.refresh_token));
            }
            if (response.data.access_token) {
                localStorage.setItem('access_token', JSON.stringify(response.data.access_token));
                localStorage.setItem('token', JSON.stringify(response.data.access_token));
            }
            dispatch({
                type: VERIFY_SUCCESS,
                payload: response,
            });

            if (response.data.active_quote_id) {
                dispatch({
                    type: CREATE_CART_SUCCESS,
                    payload: JSON.parse(response.data.active_quote_id),
                });
            }

            toast.success('logged in successfully!', { position: 'top-right' });

            setTimeout(() => {
                window.location.reload();
            }, 1000);
        } else {
            const message = response.message;
            dispatch({ type: VERIFY_FAIL, error: message });
        }
    } catch (error) {
        const message = error.message ? error.message : 'Network Error';
        dispatch({ type: VERIFY_FAIL, error: message });

        toast.error(message, {
            position: 'top-right',
        });
    }
};

export const resetPassword = (data) => async (dispatch) => {
    const body = data;
    try {
        dispatch({ type: RESET });
        const response = await apiService.post({
            url: `${BASE_URL}${ApiEndpoints.VERIFY}`,
            payload: body,
        });

        dispatch({ type: RESET_SUCCESS, payload: response });
        dispatch({
            type: VERIFY_SUCCESS,
            payload: response,
        });
        localStorage.setItem('token', JSON.stringify(response.data.access_token));
        localStorage.setItem('access_token', JSON.stringify(response.data.access_token));
        localStorage.setItem('refresh_token', JSON.stringify(response.data.refresh_token));

        toast.success(
            'Password reset successful! You are now being logged in with your new password',
            {
                position: 'top-right',
                duration: 5000, // Show for 5 seconds since it's an important message
            },
        );
    } catch (error) {
        const message = error.message ? error.message : 'Network Error';
        dispatch({ type: RESET_FAIL, error: message });
        dispatch({ type: CLEAR_REQUEST });
        toast.error(message, {
            position: 'top-right',
        });
    }
};

export const refreshToken = () => async (dispatch) => {
    let refresh_token = JSON.parse(localStorage.getItem('refresh_token'));
    let body = { refresh_token };

    try {
        dispatch({ type: REFRESH_TOKEN });
        const response = await apiService.post({
            url: `${BASE_URL}${ApiEndpoints.REFRESHTOKEN}`,
            payload: body,
        });
        localStorage.setItem('token', JSON.stringify(response.data.access_token));
        localStorage.setItem('access_token', JSON.stringify(response.data.access_token));
        dispatch({ type: REFRESH_TOKEN_SUCCESS, payload: response });
    } catch (error) {
        const message = error.message ? error.message : 'Network Error';
        dispatch({ type: REFRESH_TOKEN_FAIL, error: message });
        dispatch({ type: CLEAR_REQUEST });
        dispatch({ type: LOGOUT });
        logoutUser(dispatch);
        /* Suppress this toast when we're on /login — user is already
           where they need to be and doesn't need a session-expired alert
           on top of the form they're about to use. */
        if (!isOnLoginRoute()) {
            toast.error(message, {
                position: 'top-right',
            });
        }
        localStorage.removeItem('token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('access_token');
        window.location.reload();
    }
};
export const clearReq = () => async (dispatch) => {
    dispatch({ type: CLEAR_REQUEST });
};

export const logoutUser = async (dispatch) => {
    let refresh_token = JSON.parse(localStorage.getItem('refresh_token'));
    let body = { refresh_token: refresh_token };
    if (refresh_token) {
        try {
            dispatch({ type: LOGOUT });
            localStorage.removeItem('token');
            localStorage.removeItem('access_token');
            localStorage.removeItem('refresh_token');
            localStorage.removeItem('welcome_popup_seen');
            dispatch(setCurrenciesRates(null));
            await apiService.delete({
                url: `${BASE_URL}${ApiEndpoints.LOGOUT}`,
                payload: { data: body },
            });
        } catch (error) {
            /* Suppress on /login — the page itself calls logoutUser as
               defensive cleanup, and showing a toast for that confuses users. */
            const message = error.message ? error.message : 'Network Error';
            if (!isOnLoginRoute()) {
                toast.error(message, {
                    position: 'top-right',
                });
            }
        }
    } else {
        dispatch({ type: LOGOUT });
        dispatch(setCurrenciesRates(null));
        localStorage.removeItem('token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('access_token');
    }
};

/* ─────────────────────────────────────────────────────────────
   ROUTE HELPERS
   ───────────────────────────────────────────────────────────── */

/** True when the user is currently viewing the login page. */
const isOnLoginRoute = () => {
    if (typeof window === 'undefined') return false;
    const path = window.location.pathname || '';
    return path === '/login' || path.startsWith('/login/');
};